// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"d8a1a5e8","129":"7f83d757","396":"918f3c33"}[chunkId] + ".chunk.js";
};